//顶部导航栏组件
<script>
import MainMenu from "@/components/MainMenu.vue";
import MainUser from "@/components//MainUser.vue";
export default {
  components: {
    MainMenu,
    MainUser,
  },
  data() {
    return {
      title: "科控科技",
      iskk: true,
    };
  },
  mounted() {
    const host = window.location.host;
    this.iskk = host.includes("fjkkauto");
    this.title = this.iskk ? "科控科技" : "凯创通达";
  },
};
</script>
<template>
  <div class="top_bar">
    <div style="width: 90%; margin: auto">
      <div class="flex">
        <div class="logo">
          <img v-if="this.iskk" class="logoimg" src="../assets/KK_LOGO.png" />
          <img v-else class="logoimg" style="height: 48px;" src="../assets/bjlogoh.png" />
          <!-- <img class="foat" src="../assets/zitit.png" /> -->
          <span class="foat">{{ this.title }}</span>
        </div>
        <div class="flex-item flex">
          <!-- <div class="flex-item"></div> -->
          <div class="menu_bar">
            <MainMenu></MainMenu>
          </div>
        </div>
        <!-- <div class="search_bar">
          <Search></Search>
        </div> -->
        <div class="user_bar">
          <MainUser></MainUser>
        </div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.top_bar {
  height: 60px;
  line-height: 60px;
  /* width: 100%; */
  border-bottom: 1px solid #eeefff;
  /* position: absolute; */
  /* z-index: 1; */
  /* position: relative; */
}
/* .top_bar .inner {

} */
.top_bar .logo {
  height: 52px;
  width: 250px;
  white-space: nowrap;
}
.top_bar .logo .logoimg {
  height: 68px;
  vertical-align: middle;
}
.top_bar .logo .foat {
  padding-left: 4px;
  font-size: 28px;
  font-weight: bold;
  vertical-align: middle;
  color: #024fa4;
  letter-spacing: 2px; /*文本间隔 */
}
.top_bar .menu_bar {
  width: 100%;
  text-align: center;
}
.top_bar .inner.search_bar {
  width: 300px;
  /* position: absolute; */
}
</style>
